const Action = {
    CREATE: "create",
    UPDATE: "update",
    DELETE: "delete",
};

const Resource = {
    USER: "user",
    AGENT: "agent",
    KNOWLEDGE_BASE: "knowledge_base",
    KNOWLEDGE_ENTRY: "knowledge_entry",
    CONTACT: "contact",
    CONVERSATION: "conversation",
    MESSAGE: "message",
    PAYMENT: "payment",
    TRANSACTION: "transaction",
    AUTH_PLATFORM: "auth_platform",
    CREDENTIAL: "credential",
    MEDIA: "media",
    FILE_STORAGE: "file_storage",
    PAYMENT_SETTING: "payment_setting",
    COIN_BALANCE: "coin_balance",
    DATA_EXPORT: "data_export",
    CHANNEL: "channel",
    DATA_IMPORT: "data_import",
    TICKET: "ticket",
    TICKET_COMMENT: "ticket_comment",
    CHANNEL_HISTORICAL_IMPORT: "channel_historical_import"
};

export { Action, Resource };
